/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_fr_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter two fractions with non-zero denominators.`)
};

const es_fr_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce dos fracciones con denominadores distintos de cero.`)
};

const de_fr_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib zwei Brüche mit Nennern ungleich null ein.`)
};

const nl_fr_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vul twee breuken in met noemers die niet nul zijn.`)
};

const fr_fr_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisissez deux fractions avec des dénominateurs non nuls.`)
};

const it_fr_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci due frazioni con denominatori diversi da zero.`)
};

const pt_br2_fr_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe duas frações com denominadores diferentes de zero.`)
};

const pt_fr_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza duas frações com denominadores diferentes de zero.`)
};

const ja_fr_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分母が0でない分数を2つ入力してください。`)
};

const zh_fr_hint = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入两个分母不为零的分数。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const fr_hint = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.fr_hint(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("fr_hint", locale)
	if (locale === "en") return en_fr_hint(inputs)
	if (locale === "es") return es_fr_hint(inputs)
	if (locale === "de") return de_fr_hint(inputs)
	if (locale === "nl") return nl_fr_hint(inputs)
	if (locale === "fr") return fr_fr_hint(inputs)
	if (locale === "it") return it_fr_hint(inputs)
	if (locale === "pt-BR") return pt_br2_fr_hint(inputs)
	if (locale === "pt") return pt_fr_hint(inputs)
	if (locale === "ja") return ja_fr_hint(inputs)
	return zh_fr_hint(inputs)
};